// extracted by mini-css-extract-plugin
export default {"button-group":"ButtonPanel_button-group__qD+ko"};